module.exports = __webpack_public_path__ + "static/media/sentisis_logo.5a1c753b.svg";